// API Base URL configuration
export const API_BASE_URL = window.location.origin;

// Webhook URL (existing functionality)
export const WEBHOOK_URL = 'https://n8n.cebugrandrealty.com/webhook';

export default API_BASE_URL;
